import {useEffect, useRef, useState} from 'react';

/**
 * `playing` is true only in-view and outside `prefers-reduced-motion` - everything the hero widgets
 * render defaults to its resolved end-state, so when this is false nothing needs a separate static markup.
 */
export default function useHeroWidgetsMotion() {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    const [reducedMotion, setReducedMotion] = useState(false);

    useEffect(() => {
        const query = window.matchMedia('(prefers-reduced-motion: reduce)');
        setReducedMotion(query.matches);
        const onChange = (event) => setReducedMotion(event.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);

    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return undefined;
        }
        const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), {threshold: 0.1});
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return {ref, playing: inView && !reducedMotion};
}
